import { Skeleton } from "@/app/components/shadcn/skeleton";

const ReviewHeaderSkeleton = () => {
  return (
    <div className="space-y-3">
      <Skeleton className="h-8 w-64" />
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-8" />
          <div className="flex gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="w-4 h-4" />
            ))}
          </div>
        </div>
        <Skeleton className="h-4 w-48" />
      </div>
    </div>
  );
};

export default ReviewHeaderSkeleton;